import { Slot as SlotPrimitive } from 'radix-ui';
import React, { useId } from 'react';

import { Stack } from './Stack';
import { cn } from './utils/cn';

const Slot = SlotPrimitive.Slot;

interface InputLabelProps extends Omit<
  React.HTMLProps<HTMLLabelElement>,
  'label'
> {
  label: React.ReactNode;
}

export const InputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>(
  ({ children, className, label, ...props }, ref) => {
    const id = useId();

    return (
      <Stack gap={2}>
        <label
          {...props}
          ref={ref}
          className={cn(
            'flex flex-col gap-2 text-2xs font-bold text-text-supporting uppercase',
            className,
          )}
          htmlFor={id}
        >
          {label}
        </label>
        <Slot id={id}>{children}</Slot>
      </Stack>
    );
  },
);
